/* unplugin-vue-components disabled */import { render } from "./personalInformation.vue?vue&type=template&id=669327db&scoped=true"
import script from "./personalInformation.vue?vue&type=script&lang=js"
export * from "./personalInformation.vue?vue&type=script&lang=js"

import "./personalInformation.vue?vue&type=style&index=0&id=669327db&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669327db"]])

export default __exports__